
<template>
  <div class="edit_container">
    <div class="title_input">
      <h2>标题：</h2>
      <el-input type="text" v-model="title" placeholder="请输入文章标题" class="large-input"></el-input>
    </div>
    <div class="upload-button">
      <h2>选择文件或输入链接：</h2>
      <el-upload
      class="upload-btn"
      v-model="fileurl"
      :action="uploadUrl"
      :show-file-list="false"
      :http-request="httpRequest"
    >
      <button class="el-button el-button--default el-button--small">
        <span>点击上传文件</span>
      </button>
        <el-input v-model="fileurl" placeholder="手动输入链接地址" class="manual-input"></el-input>
    </el-upload>

    <div v-if="fileUrl" class="file-url">
      文件链接: {{ fileUrl }}
    </div>
    </div>
    <div class="select-container">
      <h2>分类：</h2>
      <el-select v-model="atype" placeholder="选择文章类型" class="large-input">
        <el-option label="最新解读" value="1"></el-option>
        <el-option label="产业解读" value="0"></el-option>
      </el-select>
    </div>

    <div class="select-container">
      <h2>标签：</h2>
      <el-input v-model="tags" placeholder="多个标签用;分隔" class="large-input">
      </el-input>
    </div>

    <button @click="saveHtml" class="center-button">保存</button>
    <div v-if="loading" class="overlay">
      <div class="loading-message">文件上传中，请等待...</div>
    </div>
  </div>
</template>






<script>
    import { UpdateWord,GetArticleWord } from '../../../api/index'
    import {Message} from 'element-ui'
    import axios from 'axios';

    export default {

        name: "MovieManage",
        data() {
            return {
            content: '',
            uploadUrl:"https://www.windustry.cn/admin/file/upload",
            title: '请输入标题',
            atype: '最新解读',
            imageUrl: '', // 存储图片地址
            tableData:[],
            total:0,
            fileUrl:'',
            currentPage:1,
            snackInfo: {},
            dialogFormVisible:false,
            dialogTitle:'',
            labelPosition:'right',
            searchInput:'',
            addcinemaId:'',
            tags:'',
            fileurl:'',
            cinemaList:[],
            loading: false // 控制遮罩栏的显示与隐藏
          }
        },
        created() {
          const query = window.location.href.split('?')[1]; // 获取 URL 中的查询参数部分（? 后面的部分）
          const urlParams = new URLSearchParams(query);
          this.url_id = urlParams.get('id');
          this.get_word(this.url_id);
        },
      methods: {

        httpRequest(op) {
              const formData = new FormData();
              formData.append('file', op.file);

              axios.post(this.uploadUrl, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then(response => {
                let json  = response.data; // 从响应中获取数据;
                if (json.code===200){
                    Message.success('上传成功')
                    this.fileurl = json.url
                    this.fileUrl = json.url
                  }
              })
              .catch(error => {
                // 处理上传失败的逻辑
                 Message.error('上传失败，请重试')
              });

            },

        async get_word(id){
            let json = await GetArticleWord(id)
          if (json.code === 200){
            this.fileurl = json.data.word
            this.title = json.data.name
            this.atype = json.data.atype
            this.tags = json.data.tags
            Message.success(json.msg)
          } else {
            Message.error(json.msg)
          }
          this.loading = false;
        },

          async saveHtml(){
            this.loading = true;
            const query = window.location.href.split('?')[1]; // 获取 URL 中的查询参数部分（? 后面的部分）
            const urlParams = new URLSearchParams(query);
            this.url_id = urlParams.get('id');
            const editorContent = this.fileurl;
          let json = await UpdateWord(this.url_id ,editorContent,this.atype,this.title,this.tags,this.fileurl);
          if (json.code === 200){
            this.$router.push('/home/order_manage');
            Message.success(json.msg)
          } else {
            Message.error(json.msg)
          }
          this.loading = false;
          },


        },
    }
</script>



<style>
.editor_wrapper {
  height: 500px; /* 设置编辑器的高度 */
  overflow-y: auto; /* 添加垂直滚动条 */
}
.large-input {
    width: 50%; /* 设置输入框宽度为父容器的100% */
    height: 40px; /* 设置输入框高度为40像素，可以根据需要调整 */
    padding: 8px; /* 设置内边距，增加输入框内容与边框的间距 */
    font-size: 16px; /* 设置字体大小，可以根据需要调整 */
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
  z-index: 9999; /* 设置遮罩栏的层级 */
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-message {
  color: white;
  font-size: 18px;
}

/* 设置全屏遮罩 */
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.center-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 50px;
  font-size: 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.title_input {
    display: flex; /* 使用 Flex 布局 */
    align-items: center; /* 垂直居中对齐 */
}
.select-container{
  display: flex; /* 使用 Flex 布局 */
    align-items: center; /* 垂直居中对齐 */
}
.select-container h2 {
  margin-right: 10px; /* 设置标题和输入框之间的间距 */
}
.title_input h2 {
    margin-right: 10px; /* 设置标题和输入框之间的间距 */
}

.title_input input {
    flex: 1; /* 输入框占据剩余空间 */
}
.upload-button {
  display: flex; /* 使用 Flex 布局 */
    align-items: center; /* 垂直居中对齐 */
}
.upload-button h2{
   margin-right: 10px; /* 设置标题和输入框之间的间距 */
}

.edit_container {
    display: flex;
    flex-direction: column;
}

.edit_container > * {
    margin-bottom: 10px; /* 为每个元素添加底部间距 */
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/children/MovieManage.vue